.consent { display: flex; flex-direction: column; gap: 6px; }
.label { display: flex; align-items: flex-start; gap: 10px; font-size: 13px; line-height: 1.5; cursor: pointer; }
.box { flex: none; width: 18px; height: 18px; margin: 1px 0 0; accent-color: var(--ink); }
.policy { align-self: flex-start; margin-left: 28px; font-family: var(--font-mono); font-size: 10px; letter-spacing: 1px; color: var(--text-secondary); text-decoration: underline; }
@media (max-width: 639px) {
  .label { min-height: 44px; }
  .policy { display: inline-flex; align-items: center; min-height: 44px; }
}
